<template>
  <Layout>
    <div>
      <PageHeader :title="title" />
      <p class="mb-4">
        {{ $t('master.address.description') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end d-flex">
          <McButtonBack href="/master/" />
        </div>
      </div>
    </div>
    <b-card class="mc-card__setting">
      <template #title>
        <span class="d-none d-sm-inline-block">
          {{ $t('master.list.address.company') }}
        </span>
      </template>
      <McGrapqlTable
        :apiClient="query"
        :fields="companyFields"
        :customHandlers="customHandlers"
        :hasCheckbox="true"
        :searchable="true"
        :withCard="false"
        :stickyHeader="false"
        trackBy="id"
        isTextWrap
        :refreshData="!loading"
        :isEmpty="noData"
        :isLoading="isLoading"
        :hasSelectAll="true"
        :hasDisabled="false"
      >
        <template #emptyState>
          <McEmptyState
            :title="$t('maintenance.nolist.noData')"
            :desc="$t('master.service.emptyState.desc')"
            class="pb-4"
            @buttonPrimaryAction="customHandlers.handleAdd"
          />
        </template>
      </McGrapqlTable>
    </b-card>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import McEmptyState from '@/components/McEmptyState'
import { mapGetters } from 'vuex'
import { DELETE_RITAGE_GEOFENCE, GET_RITAGE_GEOFENCES } from '@/services/api/master/ritage'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
    McGrapqlTable,
    McEmptyState,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customHandlers: {
        handleAdd: () => {
          return this.$router.push({ name: 'Master Ritage Create' })
        },
        handleClickRow: (item) => {
          return this.$router.push({
            name: 'Master Ritage Update',
            params: { id: item.id },
          })
        },
      },
      loading: true,
      isLoading: true,
      noData: true,
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return this.$t('menuitems.masterData.list.ritage')
    },
    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_RITAGE_GEOFENCES,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
              },
            },
          })

          if (res.data.ritageGeofences.ritageGeofences.pagination.total === 0) this.noData = true
          else this.noData = false
          this.isLoading = false
          res.data.ritageGeofences.ritageGeofences.data.forEach((item) => {
            item.id = `${item.geofenceLoading.geofenceId}-${item.geofenceDumping.geofenceId}`
            item.geofenceLoadingName = item.geofenceLoading.fenceName
            item.geofenceDumpingName = item.geofenceDumping.fenceName
          })

          return res.data.ritageGeofences.ritageGeofences
        },

        delete: async (id) => {
          const [geofenceLoadingId, geofenceDumpingId] = id.split('-')
          const res = await this.$apollo.query({
            query: DELETE_RITAGE_GEOFENCE,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                geofenceLoadingId: parseInt(geofenceLoadingId),
                geofenceDumpingId: parseInt(geofenceDumpingId),
              },
            },
          })

          if (!res.data.deleteRitageGeofence.isSuccessful) {
            this.$mcToast.error(this.$t('master.form.ritage.deleteFailed'))
          }

          return res.data.deleteRitageGeofence.isSuccessful
        },
      }
    },
    companyFields() {
      return [
        {
          key: 'ritageName',
          label: this.$t('master.form.ritage.ritageName'),
          thClass: 'mc-table--150',
          isRedirectable: true,
          sortable: true,
          isLocked: true,
        },
        {
          key: 'geofenceLoadingName',
          label: this.$t('master.form.ritage.startGeofence'),
          sortable: true,
        },
        {
          key: 'geofenceDumpingName',
          label: this.$t('master.form.ritage.endGeofence'),
          sortable: true,
        },
      ]
    },
  },
}
</script>
